<template>
    <div class="bg-main-black">
        <header class="container mx-auto">
            <navigation-menu></navigation-menu>
            <div class="pt-16 lg:flex items-center">
                <div class="lg:w-1/2 text-center">
                    <img src="./../assets/phones.png" alt="Lingua AI: Учим языки легко" class="xl:h-iphones lg:h-100 md:h-100 sm:h-100 xs:h-100">
                </div>
    
                <div class="w-auto xs:m-0 md:m-1 md:pl-24 md:pr-24 text-center">
                    <h2 class="text-white font-black lg:text-4xl md:text-3xl sm:text-xl xs:text-lg mb-4 lg:w-4/5">
                        Lingua AI: Учим языки легко
                    </h2>
                    <div class="text-white mb-8 lg:w-4/5 md:text-lg sm:text-md xs:text-sm">
                        Флеш-карточки и упражнения для легкого и эффективного изучения языков!
                    </div>
                    <div class="text-center lg:w-auto mb-4 lg:mb-0 lg:w-4/5">
<!--                        <a href="#" v-scroll-to="'#download'" class="flex-1 text-center verical-center justify-center text-sm px-6 py-3 leading-none no-underline border rounded-xl bg-main-green text-grey-lightest border-black hover:border-grey-lightest hover:text-grey-lightest hover:bg-transparent mt-4 mt-0 mr-10">
                            Download
                        </a>-->
                        <div class="inline-block">
                            <a
                                href="https://play.google.com/store/apps/details?id=ai.lingua.vetrov"
                                target="_blank"
                                class="flex items-center justify-center text-white bg-black rounded-lg py-4 px-6 text-center no-underline"
                            >
                                <div class="mr-3">
                                    <svg viewBox="30 336.7 120.9 129.2" width="30">
                                        <path fill="#FFD400"
                                              d="M119.2,421.2c15.3-8.4,27-14.8,28-15.3c3.2-1.7,6.5-6.2,0-9.7  c-2.1-1.1-13.4-7.3-28-15.3l-20.1,20.2L119.2,421.2z">
                                        </path>
                                        <path fill="#FF3333"
                                              d="M99.1,401.1l-64.2,64.7c1.5,0.2,3.2-0.2,5.2-1.3  c4.2-2.3,48.8-26.7,79.1-43.3L99.1,401.1L99.1,401.1z">
                                        </path>
                                        <path fill="#48FF48" d="M99.1,401.1l20.1-20.2c0,0-74.6-40.7-79.1-43.1  c-1.7-1-3.6-1.3-5.3-1L99.1,401.1z">
                                        </path>
                                        <path fill="#3BCCFF"
                                              d="M99.1,401.1l-64.3-64.3c-2.6,0.6-4.8,2.9-4.8,7.6  c0,7.5,0,107.5,0,113.8c0,4.3,1.7,7.4,4.9,7.7L99.1,401.1z">
                                        </path>
                                    </svg>
                                </div>
                                <div>
                                    <div class="text-xs">
                                        УСТАНОВИТЬ ИЗ
                                    </div>
                                    <div class=" font-sans text-xl font-semibold">
                                        Google Play
                                    </div>
                                </div>
                            </a>
                        </div>
<!--                        <span class="flex-2 inline-flex items-center justify-center text-center mt-4">
                            <img src="./../assets/play-button.svg" alt="play button" class="h-8 mr-2">
                            <a href="#" class="no-underline text-semibold text-grey-lightest text-lg opacity-50 hover:opacity-100">
                                <span class="md:text-lg sm:text-md md:block xs:hidden">Watch How it Works</span>
                            </a>
                        </span>-->
                    </div>
                </div>
            </div>
        </header>
    
        <svg preserveAspectRatio="xMidYMax meet" class="svg-separator sep12" viewBox="0 0 1600 200" style="display: block;" data-height="200">
          <polygon style="fill: #f8fafc;" points="-4,24 800,198 1604,24 1604,204 -4,204 "></polygon> 
          <polygon style="opacity: 1;fill: #95a5a6;" points="-4,0 800,198 1604,0 1604,11.833 800,198 -4,12 "></polygon> 
          <polygon style="opacity: 1;fill: #dae1e7;" points="-4,12 -4,24 800,198 1604,24 1604,11.833 800,198 "></polygon>
        </svg>
    </div>
</template>

<script>
    import NavigationMenu from "./NavigationMenu";

    export default {
    components: {
        NavigationMenu
    },
    data() {
        return {};
    }
    };
</script>
